/* FullScreenSpaLoader.tsx generated by @compiled/babel-plugin v2.0.0 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VWP8C%7Bheight%3A100vh%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2fBhteCmXr%7Banimation%3Aloading%202s%20infinite%7D");
import React from 'react';
import { AtlassianIcon } from '@atlaskit/logo';
import LegacyBox from '@atlaskit/primitives/box';
import { Box, Inline } from '@atlaskit/primitives/compiled';
import LegacyInline from '@atlaskit/primitives/inline';
// eslint-disable-next-line @townsquare/rules/no-xcss
import { xcss } from '@atlaskit/primitives/xcss';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import { fg } from '@townsquare/stat-sig/gate';
const spaLoaderStyles = xcss({
  height: '100vh'
});
const logoStyles = xcss({
  animation: 'loading 2s infinite'
});
const styles = {
  spaLoader: "_0jFU0VWP8C",
  logo: "_2fBhteCmXr"
};
export const FullScreenSpaLoader = (): React.JSX.Element => <UFOLoadHold name="spa-loader">
		{fg('townsquare-compiled-xcss-to-cssmap-final') ? <Inline alignBlock="center" alignInline="center" grow="fill" xcss={styles.spaLoader} testId="full-screen-spa-loader">
				<Box xcss={styles.logo}>
					<AtlassianIcon appearance="brand" size="xlarge" />
				</Box>
			</Inline> : <LegacyInline alignBlock="center" alignInline="center" grow="fill" xcss={spaLoaderStyles} testId="full-screen-spa-loader">
				<LegacyBox xcss={logoStyles}>
					<AtlassianIcon appearance="brand" size="xlarge" />
				</LegacyBox>
			</LegacyInline>}
	</UFOLoadHold>;